<div [formGroup]='parent' class="questionGaps">
  <div  
  [ngClass]="pageName === 'activities-of-daily-living' || pageName === 'dependant-activities-of-daily-living' ? 'normal-ques-style' : 'normal-ques-style mb-10' ">
    <span class="mar-top-5"> {{question.questionText}} </span>
    <span class="info-icon d-view"  *ngIf="question.helpText">
      <app-tool-tip-notification [childId]="'dropdownStandard'" [tooltipData]="initializeToolTipDateComp(question)" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver()">
      </app-tool-tip-notification>
    </span>
    <span class="info-icon mt-view"  *ngIf="question.helpText">
      <app-tool-tip-notification [childId]="'dropdownStandard'" [tooltipData]="initializeToolTipDateComp(question)" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver()">
      </app-tool-tip-notification>
    </span>
  </div>
</div>